import "../styles/leadGeneration.scss";
import * as ReactDOM from "react-dom";
import {MyIzenLeadsComponent} from '../components/leadgeneration/my-izen-leads-component';
import React from "react";
import {MyIzenApiService} from "../components/leadgeneration/services/my-izen-api.service";

const rootEl = document.getElementById( "lead-generation" );

if ( !rootEl ) {
    console.warn( 'element with id: "root" not found!' );
}
else {
    const myIzenApiService = new MyIzenApiService();

    const urlParams = new URLSearchParams( window.location.search );

    let language = urlParams.has( 'language' ) ? urlParams.get( 'language' ) as string : 'nl';
    let theme = urlParams.has( 'theme' ) ? urlParams.get( 'theme' ) as string : 'default';
    let sourceNew = urlParams.has( 'sourceNew' ) ? urlParams.get( 'sourceNew' ) : '';
    let sourceExisting = urlParams.has( 'sourceExisting' ) ? urlParams.get( 'sourceExisting' ) : '';
    let supportsBelfiusFinancing = urlParams.has( 'supportsBelfiusFinancing' ) ? urlParams.get( 'supportsBelfiusFinancing' ) as string : "true";

    // TODO: THIS HACKY WORKAROUND SHOULD BE IMPLEMENTED BY BELFIUS WHEN THEY UPDATE THEIR API CALL TO USE THE IDS
    if ( theme === 'belfius' ) {
        sourceNew = '10';
        sourceExisting = '10';
    }

    myIzenApiService.getBaseConfiguration( language, theme, sourceNew, sourceExisting, supportsBelfiusFinancing )
        .then( ( configuration ) => {
            ReactDOM.render( <MyIzenLeadsComponent configuration={configuration}/>, rootEl );
        } ).catch( ( err ) => {
        console.error( 'Failed loading the main configuration' );
    } );
}

